import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var LoadingButton = require("components/utility/LoadingButton");
var ReactTooltip = require("react-tooltip");
var Glyphicon = require("components/utility/icons/Glyphicon");

var HelpSectionLink = require("components/utility/HelpSectionLink");

require("org/preferences/activation_codes_preferences.scss");

// EVENT LISTENER FUNCTIONS TO ALERT USERS UPON LEAVING BEFORE SAVING
var preventLeavingWindowFunc = null;
var preventReloadingFunc = null;

@connect(
	(state, props) => {
		var selectedSchoolOrgs = []
		var selectedDistrictOrgs = []
		var admin = RosterSelectors.admin({state, id:CurrentUser.get().id})
		var refPrefs = {}

		var selectedSchoolOrgs = []

		if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
			selectedSchoolOrgs = RosterSelectors.schoolOrgs({
				state, conditions: { ids: admin.org_ids.school_orgs.all }
			})
		}
		if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.all) {
			var selectedDistrictOrgs = RosterSelectors.districtOrgs({
				state, conditions: { ids: admin.org_ids.district_orgs.all }
			})

			if (selectedDistrictOrgs.length > 0) {
				selectedSchoolOrgs = selectedDistrictOrgs[0].school_orgs
			}
			
		}

		return {
			admin,
			selectedSchoolOrgs
		}
	},

	 (dispatch, props)=>({

        populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['admin.org_ids'],
                cache: false
            })).then(response=>{
            	var currentAdmin = response.admins[0]
            	if (currentAdmin) {
            		if (CurrentUser.isSchoolAdmin()) {
	            		if (currentAdmin.org_ids.school_orgs && currentAdmin.org_ids.school_orgs.all.length > 0) {
	            			// LOAD SCHOOL ORGS
	            			return Promise.all([ dispatch(RosterActions.fetchSchoolOrgs({
				                filters:{ids: currentAdmin.org_ids.school_orgs.all}, 
				                embeds:['school_org.prefs'],
				                cache: false
				            }))])
	            		}
	            	} else {
	            		if (currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.all.length > 0) {
	            			// LOAD DISTRICT ORGS
	            			return Promise.all([ dispatch(RosterActions.fetchDistrictOrgs({
				                filters:{ids: currentAdmin.org_ids.district_orgs.all}, 
				                embeds:['school_org.prefs,district_org.school_orgs'],
				                cache: false
				            }))])
	            		}
	            	}
            	}
            })])
        },
		onSchoolPrefChange: (schoolOrgID, prefsUpdate) => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Activation Codes have been saved!", text: "Activation codes will be sent shortly. Hang tight!", icon: "ok-sign"
			});
			return dispatch(RosterActions.updateSchoolOrgPrefs({
				currentUserID: CurrentUser.get().id,
				schoolOrgID,
				resetPrefs: true,
				embeds:['school_org.prefs,district_org.school_orgs'],
				update: {"activation_codes": prefsUpdate}
			}))
		}
    })
)
@providePopulateData({ waitForLoad: true })
class ActivationCodesPreferences extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("ActivationCodesPreferences");

		var state = {toggleBulkEntry: false, activationCodes: [], updated: false, selectedRole: TEACHER_TYPE}
		if (props.selectedSchoolOrgs.length > 0) {
			var schoolOrgs = _.sortBy(props.selectedSchoolOrgs, (schoolOrg) =>  schoolOrg.name)
			state["selectedSchool"] = schoolOrgs[0].id
			if (schoolOrgs[0].prefs.activation_codes) {
				state["activationCodes"] = schoolOrgs[0].prefs.activation_codes
			}
		}
		this.state = state
	}

	codesHaveChanged() {
		return false
	}

	selectSchool(selectedSchool) {

		if(!this.state.updated || window.confirm("Your changes will not be saved. Are you sure you'd like to proceed?")){
			var activationCodes = _.values( _.pick(this.props.selectedSchoolOrgs, (so) => so.id == selectedSchool.target.value))[0].prefs.activation_codes
			this.setState({selectedSchool: selectedSchool.target.value, toggleBulkEntry: false, activationCodes, selectedRole: TEACHER_TYPE, updated: false })	
		} 
	}

	selectRole(i, selectedRole) {
		selectedRole = selectedRole.target.value
		if (i > -1) {
			var newAC = this.state.activationCodes
			newAC[i]["role"] = selectedRole
			this.setState({activationCodes: newAC})
		} else {
			this.setState({selectedRole})
		}
	}

	renderSchoolSelect() {
		var schoolOrgs = _.sortBy(this.props.selectedSchoolOrgs, (schoolOrg) =>  schoolOrg.name)

		var options = _.map(schoolOrgs, (school) => {
			return (
				<option value={school.id} key={school.id}> {school.name} </option>
			)
		})
		return (
			<div className="school-select">
				<b>Select a school</b>
				<select value={ this.state.selectedSchool } className="form-control gradeSelect"
					onChange={ this.selectSchool.bind(this) }>
					{ options }
				</select>
			</div>
		)
	}

	renderBulkEntry() {

		if (this.state.toggleBulkEntry) {
			return (
				<div className="bulk-entry">
					<textarea ref="bulk_entry" className="form-control" rows={10} placeholder={"You can paste teacher names and emails directly in this form.\n\nValid format:\nfirst name, last name, email\n\nExample:\nHarry, Potter, mischiefmanaged@hogwarts.edu\nMatilda, Wormwood, readingismagic@library.k21.us\n..."}/>
					<div className="action">
						<a onClick={(e) => {this.setState({toggleBulkEntry: !this.state.toggleBulkEntry})}}>hide</a>
						<button className="btn btn-default text-center" onClick={this.addBulkEntry.bind(this)}>add</button>
					</div>
				</div>
			)
		} else {
			return (
				<a onClick={(e) => {this.setState({toggleBulkEntry: !this.state.toggleBulkEntry})}}>show bulk entry</a>
			)
		}
	}

	toggleStatus(i) {
		var newAC = this.state.activationCodes
		newAC[i].status = "edit"
		this.setState({activationCodes: newAC})
	}

	removeCode(i) {
		var newAC = this.state.activationCodes
		newAC.splice(i, 1)
		if (window.confirm("Are you sure you';'d like to delete this Validation Code?")) {
			this.setState({activationCodes: newAC}, this.triggerSend.bind(this))
		}
	}

	renderCodeRow(ac, i) {

		if ("first_name" in ac) {
			if (ac.status == "pending" || ac.status == "error") {
				if (ac.status == "pending") {
					var edit = <a onClick={this.toggleStatus.bind(this, i)}>edit</a>
				}
				return (
					<tr key={ac.email} className={ac.status}>
						<td>
							<div>
								<input  disabled={true} className="form-control name-field" type="text" placeholder="First name" defaultValue={ac.first_name} />
								<input  disabled={true} className="form-control name-field" type="text" placeholder="Last name" defaultValue={ac.last_name} />
							</div>
							<input  disabled={true} className="form-control" type="text" placeholder="Email" defaultValue={ac.email} />
						</td>
						<td>
							<select value={ ac.role } disabled={true} className="form-control gradeSelect"
								onChange={ this.selectRole.bind(this, i) }>
								<option value={TEACHER_TYPE} key={"Teacher"}> Teacher </option>
								<option value={SUB_ADMIN_TYPE} key={"Sub-Admin"}> Sub Admin </option>
								<option value={HEAD_ADMIN_TYPE} key={"Head-Admin"}> Head Admin </option>
							</select>
						</td>
						<td>
							<div className="text-center">
								<div>
									<b>{ac.status}</b>
								</div>
								<div>
									{ edit }
								</div>
								<div>
									<a onClick={this.removeCode.bind(this, i)} className="remove">remove</a>
								</div>
								
							</div>
						</td>
					</tr>
				)
			} else if (ac.status == "edit") {
				return (
					<tr key={ac.email}>
						<td>
							<div>
								<input ref={"first_name_"+i} className="form-control name-field" type="text" placeholder="First name" defaultValue={ac.first_name}/>
								<input ref={"last_name_"+ i} className="form-control name-field" type="text" placeholder="Last name" defaultValue={ac.last_name}/>
							</div>
							<input ref={"email_" + i} className="form-control" type="text" placeholder="Email" defaultValue={ac.email}/>
						</td>
						<td>
							<select value={ ac.role } className="form-control gradeSelect"
								onChange={ this.selectRole.bind(this, i) }>
								<option value={TEACHER_TYPE} key={"Teacher"}> Teacher </option>
								<option value={SUB_ADMIN_TYPE} key={"Sub-Admin"}> Sub Admin </option>
								<option value={HEAD_ADMIN_TYPE} key={"Head-Admin"}> Head Admin </option>
							</select>
						</td>
						<td>
							<button className="btn btn-default" onClick={this.editCode.bind(this, i)}>validate</button>
						</td>
					</tr>
				)
			} else if (ac.status == "sent") {
				return (
					<tr key={ac.email} className={ac.status}>
						<td>
							<div>
								{ac.first_name + " " + ac.last_name }
							</div>
							<div>
								<b>{ac.email}</b>
							</div>
						</td>
						<td>
							{ ac.role }
						</td>
						<td className="text-center" >
							<b>{ ac.status }!</b>
						</td>
					</tr>
				)
			}
			
		} else {
			// LAST ROW ALLOWING USERS TO ADD NEW CODES
			return (
				<tr key={this.state.activationCodes.length + 1}>
					<td>

						<div>
							<input ref="first_name" className="form-control name-field" type="text" placeholder="First name"/>
							<input ref="last_name" className="form-control name-field" type="text" placeholder="Last name"/>
						</div>
						<input ref="email" className="form-control" type="text" placeholder="Email"/>
					</td>
					<td>
						<select value={ this.state.selectedRole } className="form-control gradeSelect"
							onChange={ this.selectRole.bind(this, -1) }>
							<option value={TEACHER_TYPE} key={"Teacher"}> Teacher </option>
							<option value={SUB_ADMIN_TYPE} key={"Sub-Admin"}> Sub Admin </option>
							<option value={HEAD_ADMIN_TYPE} key={"Head-Admin"}> Head Admin </option>
						</select>
					</td>
					<td>
						<button className="btn btn-default" onClick={this.manualAddCode.bind(this)}>add</button>
					</td>
				</tr>
			)
		}
		
	}

	renderAssistedInput() {

		var rows = _.map(this.state.activationCodes, (ac, i) => {
			return this.renderCodeRow(ac, i)
		})

		if (this.getCodesByStatus("edit").length == 0) {
			rows.push(
				this.renderCodeRow({}, 1000)
			)
		}

		return (
			<table className="table code-table">
				<thead>
					<tr>
						<th>
							Account Info
						</th>
						<th>
							Role 
							<div className='infoTooltip'>
						        <Glyphicon icon="info-sign" className="infoSign" dataTip={"Select admin only if this person needs access to all classes in the school and has no classes of their own"} />
						        <ReactTooltip effect="solid" />
						    </div>
						</th>
						<th>
							Status
						</th>
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		)
	}

	editCode(index) {
		var first_name = this.refs["first_name_" + index].value
		var last_name = this.refs["last_name_" + index].value
		var email = this.refs["email_" + index].value
		var role = this.state.activationCodes[index].role

		if (this.validateRow(first_name.trim(), last_name.trim(), email.trim(), -1)) {
			// Add to AC list
			this.addNewCode(first_name, last_name, email, role, index)
		}
	}

	manualAddCode() {
		var first_name = this.refs.first_name.value
		var last_name = this.refs.last_name.value
		var email = this.refs.email.value
		if (this.validateRow(first_name.trim(), last_name.trim(), email.trim(), -1)) {
			// Add to AC list
			this.addNewCode(first_name, last_name, email, this.state.selectedRole, -1)
		}
	}

	addBulkEntry() {
		var bulkEntry = this.refs.bulk_entry.value
		if (bulkEntry.length == 0) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Issue with bulk entry!", text: "It appears you haven't typed anything yet!", 
				icon: "exclamation-sign", type: "error" });
		} else if (bulkEntry.split("\n").length > 100 ) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Limit reached!", text: "Our sending limit is 100 codes at a time. We kindly ask you chunk your request in groups. Send a first 100 codes and then add additional ones.", 
				icon: "exclamation-sign", type: "error" }, 6000);
		} else {
			var total = bulkEntry.split("\n").length
			bulkEntry.split("\n").forEach((row, index) => {
				this.validateBulkString(row, index, total)
			})
		}
	}

	validateBulkString(row, index, total) {
		const hasThreePartsRegex = /^[^\s,]+\s*,\s*[^\s,]+\s*,\s*[^\s,]+\s*$/;
		
		if(!hasThreePartsRegex.test(row)) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Issue with line: "+ (index + 1 ) +" in bulk entry!", text: "Check that line and make sure it has a first name, last name and email separated by 2 commas!", 
				icon: "exclamation-sign", type: "error" }, 6000);
		} else {
			var parts = row.split(",")
			if (this.validateRow(parts[0].trim(), parts[1].trim(), parts[2].trim(), index)) {
				this.addNewCode(parts[0].trim(), parts[1].trim(), parts[2].trim(), TEACHER_TYPE, -1)
			}
		}
		if (index + 1 >= total) {
			this.setState({toggleBulkEntry: false})
		}
	}

	validateRow(first_name, last_name, email, index) {

		var bulkEntryAlert = ""
		if (index != -1) {
			bulkEntryAlert = " Bulk entry, line: " + (index + 1)
		} 

		if (!this.validateName(first_name)) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Issue with first name!" + bulkEntryAlert, text: "The first name you entered doesn't look right!", 
				icon: "exclamation-sign", type: "error" }, 6000);
		} else if (!this.validateName(last_name)) {
 			window.wrNotifications.triggerDropDownNotification({
				title: "Issue with last name!"+ bulkEntryAlert, text: "The last name you entered doesn't look right!", 
				icon: "exclamation-sign", type: "error" }, 6000);
		} else if (!this.validateEmail(email))	{
			window.wrNotifications.triggerDropDownNotification({
				title: "Issue with email!"+ bulkEntryAlert, text: "The email you entered doesn't look right!", 
				icon: "exclamation-sign", type: "error" }, 6000);
		} else {
			return true
		}

	}

	isEmailUnique(email) {
		var eligibleCodes = this.getCodesByStatus("pending")
		eligibleCodes =  eligibleCodes.concat(this.getCodesByStatus("sent"))
		var emails = _.map(eligibleCodes, (ac) => ac.email)
		return !emails.includes(email.toLowerCase())
	} 

	addNewCode(first_name, last_name, email, role, code_index) {
		if (this.state.activationCodes.length > 100) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Limit reached!", text: "Our sending limit is 100 codes at a time. We kindly ask you chunk your request in groups. Send a first 100 codes and then add additional ones.", 
				icon: "exclamation-sign", type: "error" }, 6000);
			return null;
		}

		if (this.isEmailUnique(email)) {
			var newAC = this.state.activationCodes
			var update = {"first_name": first_name, "last_name": last_name, "email": email.toLowerCase(), "role": role, "status": "pending"}

			// Allow for updating Single AC or ADD in bulk
			if (code_index == -1) {
				newAC.push(update)
			} else {
				newAC[code_index] = update
			}
			this.setState({activationCodes: newAC, updated: true, selectedRole: TEACHER_TYPE}, () => {
				localStorage.setItem("activation_codes", JSON.stringify(this.getCodesByStatus("pending")))
			})

		} else {
			window.wrNotifications.triggerDropDownNotification({
				title: "Duplicate email addresses!", text: "Warning, it looks like you have duplicate email addresses in your list! Duplicates have not been added.", 
				icon: "exclamation-sign", type: "error" }, 6000);
		}
	}

	validateName(name) {
		if (name.length == 0 || name.length > 20) {
			return false
		}
		return true
	}

	validateEmail(email) {
		if (!email.includes("@") || !email.includes(".") || email.length < 6) {
			return false
		}
		return true
	}

	getCodesByStatus(status) {
		return _.values(_.pick(this.state.activationCodes, (ac) => ac.status == status))
	}

	renderSendAction() {
		var pendingCodesCount = this.getCodesByStatus("pending").length
		var editCodesCount = this.getCodesByStatus("edit").length

		if (pendingCodesCount == 0) {
			return ("")
		}

		if (editCodesCount > 0) {
			return (
				<div className="text-center">
					<LoadingButton disabled={true} loading={ this.state.loading }
							text={ "Send " + pendingCodesCount + " new Activation Code(s)"}
							className={ "btn buttonSuccess" }
							onClick={ this.triggerSend.bind(this) } />
					<p className="sending-alert">
						Make sure you validate every activation code before sending them!
					</p>
				</div>
			)
		}
		return (
			<div className="text-center">
				<LoadingButton loading={ this.state.loading }
						text={ "Send " + pendingCodesCount + " new Activation Code(s)"}
						className={ "btn buttonSuccess" }
						onClick={ this.triggerSend.bind(this) } />
			</div>
		)
	}

	render() {

		if (this.props.selectedSchoolOrgs.length > 0) {
			return (
				<div className="ActivationCodesPreferences">
					<p>
						Send activation codes to teachers who need to either create a new Whooo's Reading account or need to connect their existing teacher account to the school.
					</p>
					<p>
						It's a good idea to<a onClick={ () => {$wr.redirect("/settings/rostering-method")} } target="_blank"> select a rostering method</a> before sending activation code emails.
						<HelpSectionLink featureName="sending Activation Codes to teachers and admins" linkSuffix="18733905870093" iconOnly={false} />
					</p>
				
					
					{ this.renderSchoolSelect() }
					{ this.renderBulkEntry() }
					{ this.renderAssistedInput() }
					{ this.renderSendAction() }
				</div>
			)
		} else {
			return (
				<div>
					It looks like your account isn't attached to any school. If this doesn't seem right, please contact <a>support@whooosreading.org</a>
				</div>
			)
		}
	}

	triggerSend() {
		var editCodesCount = this.getCodesByStatus("edit").length
		if (editCodesCount > 0) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Some activation codes are still being edited!", text: "Make sure you validate every activation code before sending them!", 
				icon: "exclamation-sign", type: "error" }, 6000);
		} else {
			this.props.onSchoolPrefChange(this.state.selectedSchool, this.state.activationCodes).then((result) => {
				var activationCodes = _.map(this.state.activationCodes, (code) => {
					if (code.status == "pending") {
						code["status"] = "sent"
						return code
					} else {
						return code
					}
				})
				this.setState({ activationCodes, updated: false }, () => {
					localStorage.setItem("activation_codes", "{}")
				})
			})
		}
	}

	componentWillUnmount() {
		// console.log("REMOVING EVENT LISTENERS")
		document.getElementsByClassName('linksSection')[0].removeEventListener('click', preventLeavingWindowFunc, true)
		document.getElementById('siteHeader').removeEventListener('click', preventLeavingWindowFunc, true)
		window.removeEventListener("beforeunload", preventReloadingFunc, true)
	}

	preventLeavingComponent(event) {
		if (this.state.updated) {
		   if (!window.confirm("Are you sure you\'d like to proceed? Your pending activation codes will be lost.")) {
		   		event.stopPropagation();
		   		event.preventDefault();
		   }
		}
	}


	preventReload(event) {
		if (this.state.updated) {
		    var confirmationMessage = 'Are you sure you\'d like to proceed?'
		                            + 'Your pending activation codes will be lost.';

		    (event || window.event).returnValue = confirmationMessage; //Gecko + IE
		    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
		}
		// var r = confirm("You pressed a Back button! Are you sure?!");

	    // if (r != true) {
	    // 	console.log("STAY")
	    //     // Stay on the current page.
	    //     window.history.pushState(null, null, window.location.pathname);
	    //     event.stopPropagation();
		//    	event.preventDefault();
	    // }

	}

	componentDidMount() {
		// PLACING FUNCTION WITHIN GLOBAL VAR TO ALLOW REMOVING LISTENER ON UNMOUNT
		preventLeavingWindowFunc = this.preventLeavingComponent.bind(this)
		preventReloadingFunc = this.preventReload.bind(this)

		window.addEventListener("beforeunload", preventReloadingFunc, true)
		document.getElementsByClassName('linksSection')[0].addEventListener('click', preventLeavingWindowFunc, true)
		document.getElementById('siteHeader').addEventListener('click', preventLeavingWindowFunc, true)
		
		this.loadPendingCodesFromLocal()
	}

	loadPendingCodesFromLocal() {
		let activation_codes = JSON.parse(localStorage.getItem("activation_codes"))
		_.select(activation_codes, (code) => {
			if (code.status == "pending" && this.isEmailUnique(code.email)) {
				this.addNewCode(code.first_name, code.last_name, code.email, code.role, -1) 
			}
		})
	}

}

var DISTRICT_MANAGER = "district_org"
var SCHOOL_MANAGER = "school_org"

const TEACHER_TYPE = "teacher"
const HEAD_ADMIN_TYPE = "head-admin"
const SUB_ADMIN_TYPE = "sub-admin"

module.exports = ActivationCodesPreferences;



// WEBPACK FOOTER //
// ./modules/components/org/preferences/ActivationCodesPreferences.js